<script setup lang="ts">

</script>

<template>
    <div class="lg:hidden w-full py-4">
        <NuxtImg alt="Ločilna črta" src="/images/footer/footer-contact-seperator.svg" class="w-full h-auto" />
    </div>
</template>

<style scoped>

</style>
